import React from 'react';
import './event.css'; // Updated CSS

function Event() {
const events = [
  {
    date: "January 03, 2025",
    name: "January Poya Day",
    description: "Closest Sunday for Program: January 04"
  },
  {
    date: "February 01, 2025",
    name: "February Poya Day",
    description: "Closest Sunday for Program: February 01 (Falls on Sunday)"
  },
  {
    date: "March 02, 2025",
    name: "March Poya Day",
    description: "Closest Sunday for Program: March 01"
  },
  {
    date: "April 01, 2025",
    name: "April Poya Day",
    description: "Closest Sunday for Program: March 29 or April 05"
  },
  {
    date: "May 01, 2025",
    name: "Adhi Vesak Poya Day",
    description: "Closest Sunday for Program: May 24"
  },
  {
    date: "May 30, 2025",
    name: "Vesak Poya Day",
    description: "Closest Sunday for Program: May 31"
  },


  {
    date: "June 29, 2025",
    name: "June Poya Day",
    description: "Closest Sunday for Program: June 28"
  },

  {
    date: "June 26, 2025",
    name: "Was Aradanawa ",
    description: ""
  },


  {
    date: "July 29, 2025",
    name: "July Poya Day",
    description: "Closest Sunday for Program: July 26 or August 02"
  },
  {
    date: "August 27, 2025",
    name: "August Poya Day",
    description: "Closest Sunday for Program: August 30"
  },
  {
    date: "September 26, 2025",
    name: "September Poya Day",
    description: "Closest Sunday for Program: September 27"
  },
  {
    date: "October 25, 2025",
    name: "October Poya Day",
    description: "Closest Sunday for Program: October 25 (Falls on Sunday)"
  },
  {
    date: "November 24, 2025",
    name: "November Poya Day",
    description: "Closest Sunday for Program: November 22"
  },
  {
    date: "December 23, 2025",
    name: "December Poya Day",
    description: "Closest Sunday for Program: December 20 or December 27"
  }
];

  return (
    <div className="event-container">
      <div className="event-layout">
        <div className="event-content">
          <h1 className="event-title">Events - 2025</h1>
          <p className="event-description">Join us for these sacred and meaningful Buddhist observances at Ehipassiko Buddhist Centre.</p>

          <div className="event-list">
            {events.map((event, index) => (
              <div key={index} className="event-card">
                <h2 className="event-name">{event.name}</h2>
                <p className="event-date">{event.date}</p>
                <p className="event-details">{event.description}</p>
              </div>
            ))}
          </div>

          <footer className="event-footer">
            <p>🙏 May your path be illuminated with wisdom, peace, and joy. 🙏</p>
          </footer>
        </div>

        <div className="event-gallery">
          <h2 className="gallery-title">Event Moments</h2>
          <div className="gallery-photos">
            {/* <img src="/event ehi1.jpeg" alt="Event 1" />
            <img src="/event ehi2.jpeg" alt="Event 2" />
            <img src="/event ehi3.jpeg" alt="Event 3" /> */}
            {/* <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" />
            <img src="/img1.JPG" alt="Event 1" />
            <img src="/img2.JPG" alt="Event 2" />
            <img src="/img3.jpg" alt="Event 3" />
            <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" />
            <img src="/img1.JPG" alt="Event 1" />
            <img src="/img2.JPG" alt="Event 2" />
            <img src="/img3.jpg" alt="Event 3" />
            <img src="/img4.JPG" alt="Event 4" />
            <img src="/img5.JPG" alt="Event 5" />
            <img src="/img6.JPG" alt="Event 6" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Event;
